import React, { useCallback, useMemo, useState } from 'react';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';
import VirtualTable from 'components/VirtualTable/VirtualTable';
import { getColumns } from './columns';
import Label from 'components/Label/Label';
import { Dimmer, Loader } from 'semantic-ui-react';
import { usePreparationOrderDetailTableData } from 'hooks/usePreparationOrderDetailTableData';
import ECILogo from 'components/ECILogo/ECILogo';
import './preparation-orders-table.scss';

export default function PreparationOrderDetailTable({
  preparationOrder,
  onBatchPrintingFinished = () => {},
}) {
  const [isBatchPrinting, setIsBatchPrinting] = useState(false);
  const data = usePreparationOrderDetailTableData(preparationOrder);
  const getRowClassNames = useCallback((row) => {
    const { pendingLabels } = row?.original;
    return {
      'order-preparation-detail-table__row--is-finished': !pendingLabels,
    };
  }, []);

  const columns = useMemo(
    () =>
      getColumns({
        preparationOrder,
        isBatchPrinting,
        setIsBatchPrinting,
        onBatchPrintingFinished,
      }),
    [
      preparationOrder,
      isBatchPrinting,
      setIsBatchPrinting,
      onBatchPrintingFinished,
    ],
  );

  return (
    <>
      <Dimmer active={isBatchPrinting} inverted>
        <Loader>Imprimiendo…</Loader>
      </Dimmer>
      <div className="order-preparation-detail-table">
        <div className="order-preparation-detail-table__meta">
          <Label>Detalles</Label>
          <div className="order-preparation-detail-table__logos">
            {preparationOrder.has_external_labels && <ECILogo />}
            <CarrierLogo code={preparationOrder?.agency?.agency_code} />
          </div>
        </div>
        <VirtualTable
          columns={columns}
          data={data}
          rowClassNames={getRowClassNames}
          initialState={{
            hiddenColumns: preparationOrder.labels.some(
              (label) => !!label?.external_label_id,
            )
              ? []
              : ['pendingExternalLabels'],
          }}
        />
      </div>
    </>
  );
}
